import { Text } from '../text'
import s from './style.module.scss'

interface IFormError {
  message?: string
}

function FormError({ message }: IFormError) {
  return message ? (
    <Text color='danger' className={s['error-message']}>
      {message}
    </Text>
  ) : (
    <span />
  )
}

export default FormError
